import React from 'react'
import {ReactComponent as BackIcon} from '../../Icons/back.svg';
import { useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import { useDispatch } from 'react-redux';
import TabSearch from '../../NewComponent/TabSearch/tabSearch';

export default function KeyTagFilter() {
    const tagState = useSelector(state=>state.keyTag);
    const dispatch = useDispatch();
    const {getkeyTagPayload, KeyTagsDataSearchQuery} = bindActionCreators(Actions, dispatch);
    const onChangeText = (e)=>{
        KeyTagsDataSearchQuery(e.target.value)
    }
  return (
    <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
        <div>
            <span style={{color:'#2A364A', fontSize:'18px', lineHeight:'24px', fontWeight:'400'}}><BackIcon style={{cursor: 'pointer'}} onClick={()=>getkeyTagPayload(null)} />
            &nbsp;{tagState.tagSelectedPayload===null?"":tagState?.tagSelectedPayload?.tag}</span>
        </div>
        <div style={{width:'150px'}}>
            <TabSearch size={'large'} val={tagState.searchQuery} onChangeFunc={onChangeText} />
        </div>
    </div>
  )
}
